/* eslint-disable global-require */
import { required } from '@validations'
import store from '@/store/index'
import AuthApis from '@/services/apis/auth'

const auth = new AuthApis()
export default {

  data() {
    return {
      email: this.$route.query.email,
      token: this.$route.query.token,
      password_confirmation: '',
      password: '',
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      required,
      password1FieldType: 'password',
      password2FieldType: 'password',
      pending: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    async submit() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        this.pending = true
        const parameter = {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        }
        auth.resetPassword(parameter).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 3000,
            showConfirmButton: false,
          })
          if (res.status === 419) {
            this.$router.push(`/${this.$i18n.locale}/forgot-password`)
          } else if (res.status === 201) {
            this.$router.push(`/${this.$i18n.locale}/login`)
          }
        }).finally(() => {
          this.pending = false
        })
      }
    },
  },
}
